var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.667A8.336 8.336 0 0 0 3.667 12c0 4.6 3.733 8.333 8.333 8.333S20.333 16.6 20.333 12 16.6 3.667 12 3.667zM9.742 15.575L6.75 12.583a.83.83 0 1 1 1.175-1.175l2.408 2.4 5.734-5.733a.83.83 0 1 1 1.175 1.175l-6.325 6.325a.83.83 0 0 1-1.175 0z"
  })));
};
export default SvgCheckmark;